import get from 'lodash/get';
import { Form } from 'react-bootstrap';
import { FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';
import { ApiError } from '../../../api';
import { FormFeedback } from '../FormFeedback';
import { FormFieldVisibility } from '../FormLabel';
import { FormLabel } from '../FormLabel/FormLabel';

interface FormRadioFieldProps {
  name: string;
  label: string;
  serverErrors?: ApiError;
  errors: FieldErrors<FieldValues>;
  register: UseFormRegister<FieldValues>;
  required?: boolean;
  srOnlyLabel?: boolean;
  visibility?: FormFieldVisibility;
}

export const FormRadioField = ({
  name,
  label,
  serverErrors,
  errors,
  register,
  required = false,
  srOnlyLabel = false,
  visibility,
  ...rest
}: FormRadioFieldProps & Parameters<typeof Form.Check>[0]) => {
  return (
    <Form.Group className="mb-3" controlId={name}>
      <FormLabel required={required} visibility={visibility} srOnlyLabel={srOnlyLabel}>
        {label}
      </FormLabel>
      <Form.Check
        type="radio"
        label="Yes"
        value="true"
        required={required}
        {...register(name)}
        {...rest}
      />
      <Form.Check
        type="radio"
        label="No"
        value="false"
        required={required}
        {...register(name)}
        {...rest}
      />
      <Form.Check
        type="radio"
        label="N/A"
        value="null"
        required={required}
        {...register(name)}
        {...rest}
      />
      <FormFeedback clientError={errors[name]} serverErrors={get(serverErrors?.body, name)} />
    </Form.Group>
  );
};
